<template>
  <div>
    <el-dialog
      title="Edit image"
      append-to-body
      width="90vw"
      top="4vh"
      :visible.sync="dialogFormVisible"
    >
      <image-form
        :id="id"
        inModal
        @submit="submitForm"
        :only-show-cover-crop="onlyShowCoverCrop"
        :only-show-gallery-crop="onlyShowGalleryCrop"
        :only-show-normal-crop="onlyShowNormalCrop"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelForm()">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ImageForm from '@/views/Image/ImageForm'

export default {
  data() {
    return {
      dialogFormVisible: false,
      id: null
    }
  },
  props: {
    onlyShowNormalCrop: {
      default: false
    },
    onlyShowCoverCrop: {
      default: false
    },
    onlyShowGalleryCrop: {
      default: false
    }
  },
  methods: {
    openDialog(value) {
      this.id = value
      this.dialogFormVisible = true
    },
    cancelForm() {
      this.dialogFormVisible = false
      this.$emit('cancel')
    },
    submitForm() {
      this.dialogFormVisible = false
      this.$emit('formSubmitted')
    }
  },
  components: {
    ImageForm
  }
}
</script>
